import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
})
export class FilterPipe implements PipeTransform {
  transform(listArray: any[] | null | undefined, field: string | null = null, search: string = ''): any[] {
    if(!listArray) {
      return [];
    }
    const array = listArray.slice();

    if(!search || !search.trim()) {
      return array;
    }

    const handler = {
      get(target: any, prop: string) {
        const keys = prop.split('.');
        let value = target;

        for(const key of keys) {
          if(value && Object.hasOwn(value, key)) {
            value = value[key];
          }
          else {
            return '';
          }
        }
        return value;
      }
    };

    return array.filter(item => {
      if(field) {
        const proxy = new Proxy(item, handler);
        return proxy[field].toLowerCase().includes(search.toLowerCase());
      }
      return item.toLowerCase().includes(search.toLowerCase());
    });
  }

}
